import { render, staticRenderFns } from "./EventSelectModal.vue?vue&type=template&id=1b4c0850&"
import script from "./EventSelectModal.vue?vue&type=script&lang=js&"
export * from "./EventSelectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports